module.exports = __webpack_public_path__ + "static/media/me3_Icon_PayAfterYouPass.0dcf7ec3.svg";